

export default {
    props: ['instances','instance', 'collone1Diplomas', 'collone2Diplomas', 
    'collone3Diplomas', 'nomCollone1', 'nomCollone2', 'nomCollone3', 
    'global', 'campusText', 'campusLogoHeader', 'campusLogoHeaderOffresValidation','rootLevel'],

    data() {
        return {
            ref: null,
            showListDiploma: false,
            openNavBar: false,
        };
    },
    methods: {
        openDiplomasList(event) {
            this.showListDiploma = !this.showListDiploma;
            this.showListCampus = false;
        },
        close(e) {
            if (!this.$el.contains(e.target)) {
                this.showListDiploma = false
            }
        }
    },
    mounted() {
        document.addEventListener('click', this.close)
    },
    beforeDestroy() {
        document.removeEventListener('click', this.close)
    }

}
